export default "__VITE_ASSET__CRo2tBlj__"